<template>
  <v-menu close-on-content-click
          open-on-hover
          offset-y
          close-delay="300">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="normal-btn-text body-1 font-weight-bold"
        v-on="on">
        Indicadores
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        link
        active-class="orange--text"
        :disabled="!hasRoleComprador && !hasModuleGestorFrete
              && !hasRoleRequisicao && !hasRoleAprovador &&
              !hasRoleAprovadorRequisicao && !hasRoleGestorCompras"
        to="/meu-painel"
      >
        <v-list-item-icon>
          <v-icon>mdi-monitor-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Meu painel</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        active-class="orange--text"
        :disabled="!hasRoleComprador && !hasModuleGestorFrete
              && !hasRoleAprovador && !hasRoleAprovadorRequisicao
              && !hasRoleGestorCompras"
        to="/metabase/dashboard"
      >
        <v-list-item-icon>
          <v-icon>mdi-chart-bar</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Dashboard
            <v-chip label x-small class="secondary ml-3">Novo</v-chip>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        active-class="orange--text"
        v-if="hasModuleGestorFrete && !hasRoleAprovadorRequisicao && !hasRoleAprovador
        && !hasRoleGestorCompras"
        to="/dashboard-frete"
      >
        <v-list-item-icon>
          <v-icon>mdi-truck-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Indicadores de frete</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        active-class="orange--text"
        :disabled="!hasRoleComprador && !hasRoleAprovadorRequisicao && !hasRoleAprovador
        && !hasRoleGestorCompras"
        to="/indicador-fornecedores"
      >
        <v-list-item-icon>
          <v-icon>mdi-factory</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Fornecedores</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['user', 'hasRoleComprador', 'hasRoleRequisicao', 'hasModuleGestorFrete', 'hasRoleAprovadorRequisicao', 'hasRoleAprovador', 'hasRoleGestorCompras']),
  },
};
</script>
